import routerOptions0 from "/tmp/build_015bb7a9/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  scrollBehaviorType: "smooth",
  hashMode: false
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}